<template>
  <div class="browser-page">
    <section class="browser-hero">
      <div class="browser-hero__overlay"></div>
      <div class="browser-hero__content container">
        <h1>Wyszukiwarka usług</h1>
        <p>Znajdź usługę dla swojego pupila w najbliższej okolicy.</p>
      </div>
    </section>

    <section class="browser-search section">
      <div class="container">
        <div class="browser-search__card">
          <h2>Wyszukaj usługę</h2>

          <div class="browser-search__form">
            <div class="field field--name">
              <input type="text" placeholder="szukana usługa" id="serviceNameInput" v-model="name">
            </div>

            <div class="field field--state">
              <select name="serviceCategoryInput" id="serviceCategoryInput" v-model="state">
                <option value="">-- wybierz województwo --</option>
                <option :value="state.value" v-for="state in states" :key="state.value">{{ state.name }}</option>
              </select>
            </div>

            <div class="field field--submit">
              <button
                  type="button"
                  class="btn btn--primary"
                  @click="() => {
                  if(name.length > 2 || name.length == 0){
                    setSearchParams()
                  }else{
                    appStore.setIsAlert('wpisz minimum 3 litery')
                  }
                }"
              >
                Szukaj
              </button>
            </div>

            <div class="field field--reset">
              <button
                  type="button"
                  class="btn btn--ghost"
                  @click="() => {
                  name = ''
                  selectedCategory = ''
                  state = ''
                  $router.push('/browser')
                  hidePage = false
                  itemsPage = 1
                  itemsDisplayed = '9'
                  getServices()
                }"
              >
                Resetuj
              </button>
            </div>
          </div>

          <div class="browser-categories">
            <span
                v-for="category in categories"
                :key="category.id"
                class="browser-categories__item"
                :class="{ 'browser-categories__item--active': selectedCategory == category.id }"
                @click="() => selectedCategory = category.id"
            >
              {{ category.name }}
            </span>
          </div>
        </div>
      </div>
    </section>

    <section class="section browser-results">
      <div class="container">
        <div class="section__head">
          <h2>Lista usług</h2>
          <span v-if="itemsCount">Wyników: {{ itemsCount }}</span>
        </div>

        <div class="browser-toolbar" v-if="!hidePage">
          <div class="browser-toolbar__limit">
            <label for="itemsDisplayed">Na stronę:</label>
            <select name="itemsDisplayed" id="itemsDisplayed" v-model="itemsDisplayed" @change="() => {
              itemsPage = 1
              filterServices()
            }">
              <option value="9">9</option>
              <option value="15">15</option>
              <option value="21">21</option>
              <option value="27">27</option>
              <option value="33">33</option>
              <option value="39">39</option>
            </select>
          </div>

          <div class="browser-pagination" v-if="!hidePage && itemsCount > 0">
            <button class="browser-pagination__arrow" @click="() => {
              if(itemsPage > 1){
                itemsPage -= 1
                filterServices()
              }
            }" :disabled="itemsPage <= 1">‹</button>
            <span>{{ itemsPage }}/{{ Math.ceil(itemsCount/Number(itemsDisplayed)) }}</span>
            <button class="browser-pagination__arrow" @click="() => {
              if(itemsPage < Math.ceil(itemsCount/Number(itemsDisplayed))){
                itemsPage += 1
                filterServices()
              }
            }" :disabled="itemsPage >= Math.ceil(itemsCount/Number(itemsDisplayed))">›</button>
          </div>
        </div>

        <div v-if="items">
          <ServiceModal/>
          <div class="browser-grid" v-if="items.length > 0">
            <ServiceCardVue
                v-for="item in items"
                @openServiceModal="() => $router.push({path: '/browser', query: {serviceID: item.id}})"
                :price="item.price"
                :key="item.id"
                :img="item.photo_url"
                :name="item.name"
                :state="states.filter(state => state.value == item.state_id)[0].name"
                :ishighlighted="item.active"
                :category="categories.filter(category => category.id == item.user.category_id)[0].name"
                :is-advance="item.advanceAmount ? true : false"
                :should-show-action-button="true"
            />
          </div>
          <div v-else class="browser-empty">
            <h3>Nie znaleziono usług</h3>
          </div>
        </div>
        <div class="browser-empty" v-else>
          <h3>Nie znaleziono usług</h3>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from 'axios'
import { useMeta } from 'vue-meta'
import ServiceCardVue from '@/components/SpecialComponents/ServiceCard.vue'
import ServiceModal from '@/components/SpecialComponents/ServiceModal.vue'
import { useAppStore } from '@/stores/app';

export default{
  name:'BrowserVue',
  setup () {
    useMeta({title: 'Wyszukiwarka'})

    return {
      appStore: useAppStore(),
    }
  },
  data(){
    return{
      name: '',
      states: [],
      state: '',
      categories: [],
      selectedCategory : '',
      sortOption: '1',
      itemsDisplayed: '9',
      itemsPage: 1,
      itemsCount: '',
      additionalOptions: false,
      items: null,
      hidePage: false
    }
  },
  props:{},
  mounted(){
    this.setFilters()
    this.getStates()
    this.getCategories()
    if(this.$route.query.state || this.$route.query.category || this.$route.query.name){
      this.filterServices()
    }else{
      this.getServices()
    }
  },
  components:{ ServiceCardVue, ServiceModal },
  methods:{
    setFilters(){
      this.$route.query.name ? this.name = this.$route.query.name : this.name = ''
      this.$route.query.state ? this.state = this.$route.query.state : this.state = ''
      this.$route.query.category ? this.selectedCategory = this.$route.query.category : this.selectedCategory = ''
    },
    getStates(){
      axios.get('/State').then(res => {
        res.data.forEach((item) => {
          const ob = {
            name: item.name,
            value: `${item.id}`
          }
          this.states.push(ob)
        })
      })
    },
    getCategories(){
      axios.get('/Categories').then(res => {
        res.data.forEach((item) => {
          const ob  = {
            name: item.name,
            id: `${item.id}`
          }
          this.categories.push(ob)
        })
      })
    },
    getServices(){
      const params = {
        page: this.itemsPage,
        limit: this.itemsDisplayed
      }
      axios.post('/Services', params).then(res => {
        this.itemsCount = res.data.count
        this.items = res.data.items
      })
    },
    setSearchParams(){
      this.$router.push({path: '/browser', query: {name: this.name, state: this.state, category: this.selectedCategory}}).then(() => {
        this.filterServices()
      })
    },
    filterServices(){
      this.items = []
      const ob = {
        page: this.itemsPage,
        limit: this.itemsDisplayed
      }
      if(this.$route.query.category){
        ob.category_id = this.$route.query.category
      }
      if(this.$route.query.state){
        ob.state_id = this.$route.query.state
      }
      if(this.$route.query.name){
        ob.name = this.$route.query.name
      }
      axios.post('/Services', ob).then(res => {
        this.itemsCount = res.data.count
        this.items = res.data.items
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.browser-page{
  background: #f9fafb;
  color: #1f2937;
  overflow-x: hidden;
  border-radius: 12px;
}
.container{
  width: min(1200px, calc(100% - 32px));
  margin: 0 auto;
}
.section{
  padding: 24px 0;
}
.section__head{
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e5e7eb;
  padding-bottom: 12px;
  margin-bottom: 20px;
}

.browser-hero{
  position: relative;
  min-height: 240px;
  display: flex;
  align-items: center;
  background-size: cover;
  background-position: center;
  &__overlay{
    position: absolute;
    inset: 0;
    background: rgba(31, 41, 55, .65);
  }
  &__content{
    position: relative;
    z-index: 1;
    color: #fff;
    h1{
      margin: 0 0 8px;
      font-size: clamp(2.8rem, 5vw, 4.8rem);
    }
    p{
      margin: 0;
      color: #e5e7eb;
      font-size: 1.8rem;
    }
  }
}

.browser-search{
  padding-top: 20px;
  &__card{
    background: #fff;
    border-radius: 14px;
    border: 1px solid #e5e7eb;
    box-shadow: 0 15px 40px rgba(0,0,0,.12);
    padding: 22px;
    h2{
      text-align: center;
      margin: 0 0 16px;
    }
  }
  &__form{
    display: grid;
    grid-template-columns: repeat(12, minmax(0, 1fr));
    gap: 12px;
    align-items: stretch;

    .field{ min-width: 0; }
    .field--name{ grid-column: span 5; }
    .field--state{ grid-column: span 4; }
    .field--submit{ grid-column: span 2; }
    .field--reset{ grid-column: span 1; }

    input, select{
      width: 100%;
      min-width: 0;
      border: 1px solid #d1d5db;
      border-radius: 8px;
      padding: 11px 12px;
      font-size: 1.5rem;
      background: #fff;
      box-sizing: border-box;
    }

    input:focus, select:focus{
      outline: none;
      border-color: #10b981;
      box-shadow: 0 0 0 1px #10b981;
    }
  }
}

.btn{
  border: none;
  border-radius: 8px;
  width: 100%;
  min-height: 44px;
  font-weight: 700;
  cursor: pointer;
  transition: .2s;
}
.btn--primary{
  background: #10b981;
  color: #fff;
}
.btn--primary:hover{ background: #059669; }
.btn--ghost{
  background: #f3f4f6;
  color: #374151;
}
.btn--ghost:hover{ background: #e5e7eb; }

.browser-categories{
  margin-top: 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  &__item{
    border: 1px solid #d1d5db;
    background: #fff;
    border-radius: 999px;
    padding: 8px 14px;
    cursor: pointer;
    transition: .2s;
    font-size: 1.4rem;
  }
  &__item:hover{
    border-color: #10b981;
    color: #065f46;
  }
  &__item--active{
    background: #ecfdf5;
    border-color: #10b981;
    color: #065f46;
    font-weight: 700;
  }
}

.browser-toolbar{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  gap: 12px;
  flex-wrap: wrap;
  &__limit{
    display: flex;
    align-items: center;
    gap: 8px;
    label{
      color: #374151;
    }
    select{
      border: 1px solid #d1d5db;
      border-radius: 8px;
      padding: 8px 10px;
      background: #fff;
    }
  }
}

.browser-pagination{
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  &__arrow{
    width: 34px;
    height: 34px;
    border: none;
    border-radius: 8px;
    background: #10b981;
    color: #fff;
    cursor: pointer;
    font-size: 2rem;
    line-height: 1;
  }
  &__arrow:disabled{
    opacity: .4;
    cursor: not-allowed;
  }
}

.browser-grid{
  margin-top: 16px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}
.browser-empty{
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 120px;
}

@media (max-width: 1100px){
  .browser-search__form{
    grid-template-columns: repeat(6, minmax(0, 1fr));
    .field--name{ grid-column: span 3; }
    .field--state{ grid-column: span 3; }
    .field--submit{ grid-column: span 3; }
    .field--reset{ grid-column: span 3; }
  }
}
@media (max-width: 900px){
  .browser-grid{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 640px){
  .browser-search__form{
    grid-template-columns: 1fr;
    .field--name,
    .field--state,
    .field--submit,
    .field--reset{
      grid-column: auto;
    }
  }

  .browser-grid{
    grid-template-columns: 1fr;
  }

  .section__head{
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}
</style>